/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  Featured and Spotlight listings api limits
 */

export const DEFAULT_FEATURED_LIMIT = 3
// We still show max 3 featured listings but limit to 6 so we can still get max 3 after
// deduping from spotlight listings on first call on map/list
export const DEFAULT_FEATURED_API_LIMIT = 6
export const DEFAULT_SPOTLIGHT_LIMIT = 3
// new limits for spotlight increase
export const DEFAULT_FEATURED_API_LIMIT_NEW = 9
export const DEFAULT_SPOTLIGHT_LIMIT_NEW = 6
